/* global bootstrap */
'use strict';

/* Fancybox */
import {Fancybox} from "@fancyapps/ui/dist/fancybox/fancybox.umd.js";

require('!style-loader!css!@fancyapps/ui/dist/fancybox/fancybox.css');
//import autosize from 'autosize';
/* Slick Carousel */
// import 'slick-carousel';
// require('!style-loader!css!slick-carousel/slick/slick.css');
/* jQuery Match Height */
//import 'jquery-match-height';

var use_gmap = true;

// Force CSS update
// https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/30#issuecomment-256958209
// Update 15/07/2022, inspiré de https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/30#issuecomment-294845326
// Update 28/10/2022 : en fait, il faut supprimer le fichier CSS de base vu que la nouvelle CSS est injectée via le Hot module
if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
        const reporter = window.__webpack_hot_middleware_reporter__
        const success = reporter.success
        reporter.success = function () {
            document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
                if (link.href.match(/main.css/) || link.href.match(/main_[^.]+.css/)) {
                    link.parentNode.removeChild(link);
                }
            });
            success()
        }
    }
}

(function ($) {

    function is_touch_device() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }

// Gmap
    function initMap() {

        // Create a map object and specify the DOM element for display.
        if (jQuery('#gmap').length) {
            var myLatLng = new google.maps.LatLng(parseFloat(jsData.gmap_center.lat), parseFloat(jsData.gmap_center.lng));
            var mapOptions = {
                center: myLatLng,
                scrollwheel: false,
                zoom: parseInt(jsData.gmap_zoom)
            };
            if (jsData.gmap_styles !== "" && jsData.gmap_styles !== null && jQuery.parseJSON(jsData.gmap_styles)) {
                mapOptions.styles = jQuery.parseJSON(jsData.gmap_styles);
            }
            var map = new google.maps.Map(document.getElementById('gmap'), mapOptions);
            // Marker options
            var marker_options = {
                position: myLatLng,
                map: map,
            };
            // Marker image
            if (jsData.gmap_marker_icon !== "" && jsData.gmap_marker_icon !== null) {
                marker_options.icon = {
                    url: jsData.gmap_marker_icon.url,
                    // Width conseillée : 20px.
                    size: new google.maps.Size(jsData.gmap_marker_icon.width, jsData.gmap_marker_icon.height),
                    // The origin for this image is (0, 0). (top left)
                    origin: new google.maps.Point(0, 0),
                    // Automatically center top the icon
                    anchor: new google.maps.Point((jsData.gmap_marker_icon.width / 2), jsData.gmap_marker_icon.height)
                };
            }
            var marker = new google.maps.Marker(marker_options);

            // Relocate on resize
            google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(myLatLng);
            });

            // Infowindow
            var infowindowContent, infowindow;
            if (jsData.address) {
                infowindowContent = '<div class="h4">' + jsData.site_name + '</div>' + jsData.address;
                infowindow = new google.maps.InfoWindow({
                    content: infowindowContent
                });
                marker.addListener('click', function () {
                    infowindow.open(map, marker);
                });
            }
        }
    }

    function smoothScroll(hash) {
        hash = hash.replace(/#goto-(.+)/, '#$1');
        if ($(hash).length) {
            var offset_top = $(hash).offset().top;
            if ($('.fixed-top').length) {
                offset_top = offset_top - $('.fixed-top').outerHeight();
            }
            if ($('#wpadminbar').length) {
                offset_top = offset_top - $('#wpadminbar').outerHeight();
            }
            $('html, body').animate({
                scrollTop: offset_top
            });
        }
    }

    function popupCenter(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = typeof (window.screenLeft) !== "undefined" ? window.screenLeft : screen.left;
        var dualScreenTop = typeof (window.screenTop) !== "undefined" ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

    // Permet d'afficher la map une fois le consentement accepté sans recharger la page
    // Basé sur : https://complianz.io/custom-google-maps-implementation/
    $(document).on('cmplz_run_after_all_scripts GmapsIsLoaded', function () {
        if (use_gmap && typeof google !== 'undefined') {
            initMap();
        }
    });

    $(window)
        .on('load', function () {
            $('body').removeClass('firstload');
        })
        .on('load resize statechangecomplete', function () {
            if (is_touch_device()) {
                $('body').addClass('touch-device');
            } else {
                $('body').removeClass('touch-device');
            }
        })
        .on('load statechangecomplete', function () {

            // Enable tooltips everywhere
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl);
            });

            // Enable popovers everywhere
            const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
            popoverTriggerList.map(function (popoverTriggerEl) {
                return new bootstrap.Popover(popoverTriggerEl, {html: true, trigger: 'focus'});
            });

            if (window.location.hash) {
                setTimeout(function () {
                    smoothScroll(window.location.hash);
                }, 100);
            }

            $('.countdown').countdown('2023/09/23', {elapse: true})
                .on('update.countdown', function (event) {
                    console.log('event', event.offset);
                    let $layout = $('.countdown-layout');

                    if (event.elapsed) { // Either true or false
                        // Counting up...
                        $layout.find('.countdown-section-week').remove();
                        $layout.find('.countdown-section-second').remove();
                    } else {
                        // Countdown...
                        $layout.find('.countdown-section-year').remove();
                        if (event.offset.weeksToMonth === 0) {
                            $layout.find('.countdown-section-week').remove();
                        }
                    }
                    $(this).html(event.strftime($layout.html()));
                });

            Fancybox.defaults.Hash = false;
            Fancybox.bind("[data-fancybox]:not(.slick-cloned)");
        });

    $('body')
        .on('click', '.action-social-share', function (e) {
            e.preventDefault();
            popupCenter($(this).attr('href'), '', 650, 360);
        })
        .on('click', 'a[href^="#"]', function (event) {
            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "" && $(this).data('toggle') != 'tab') {
                // Prevent default anchor click behavior
                event.preventDefault();
                smoothScroll(this.hash);
            } // End if
        })
        .on('mouseenter mouseleave', '.dropdown-hover', function (e) {
            if ($(window).width() >= 992) {
                var _d = $(this).find('.dropdown-menu').eq(0);
                _d[(e.type === "mouseenter") ? 'addClass' : 'removeClass']('show');
            }
        })
        .on('change', 'select.form-control, .custom-select', function () {
            if ($(this).val() !== "") {
                $(this).removeClass('place_holder');
            } else {
                $(this).addClass('place_holder');
            }
        });

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/main.js